
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import './TimeOfDayEditor.scss'
import TimeOfDay from '../models/TimeOfDay';

@Component({
    template: require("./TimeOfDayEditor.vue.html"),
    components: {
        
    }
})
export class TimeOfDayEditor extends Vue {

    @Prop({default: null})  
    timeOfDay: TimeOfDay;

    @Prop({default: false})  
    locked: boolean;

    @Prop({default: false})  
    loading: boolean;

    editedTimeOfDay: TimeOfDay = new TimeOfDay(0, 0);
    editedTime: string = "";
    focused: boolean = false;

    @Watch('timeOfDay.value')
    onTimeOfDayChanged(val, oldVal) {
        // console.log("TimeOfDayEditor", "onTimeOfDayChanged", "val:", val, "oldVal: ", oldVal);
        if (val.empty){
            this.editedTimeOfDay.empty = true;
            this.editedTime = "";
            return;
        }
        this.editedTimeOfDay.value = this.timeOfDay.value;
        this.editedTime = this.timeOfDay.value;
    }

    @Watch('editedTimeOfDay.value')
    onEditedTimeOfDayChanged(val, oldVal) {
        // console.log("TimeOfDayEditor", "onEditedTimeOfDayChanged", "val:", val, "oldVal: ", oldVal);
        if (val.empty){
            this.editedTime = "";
            return;
        }
        this.editedTime = this.editedTimeOfDay.value;
    }

    valid: boolean = true;
    textField: any;

    constructor(o: any) {
        super(o);
        this.editedTimeOfDay = new TimeOfDay(0, 0);
    }

    mounted() {
        this.editedTimeOfDay = new TimeOfDay(this.timeOfDay.hours, this.timeOfDay.minutes);
        this.editedTime = this.editedTimeOfDay.value;
        this.textField = this.$refs.textField;
    }

    onEnterKeyUp() {
        // console.log("TimeOfDayEditor", "onEnterKeyUp");
        this.textField.$refs.input.blur();
    }

    onFocus(e: Event) {
        this.focused = true;
        (e.target as any).select();
    }

    onBlur() {
        // console.log("TimeOfDayEditor", "onBlur");
        this.focused = false;
        this.submit();
    }

    onWheel(e: WheelEvent) {
        if (this.focused) {
            e.preventDefault();
            let deltaMinutes = 0;
            if (e.deltaY > 0 || e.deltaY < 0) {
                deltaMinutes = e.deltaY < 0 ? 10 : -10;
                // Create a temporary timeofday to perform the update with
                const updatedTimeOfDay = new TimeOfDay(0, 0);
                updatedTimeOfDay.value = this.editedTime;
                // Change the time
                updatedTimeOfDay.addMinutes(deltaMinutes);
                // Copy to view and viewmodel
                this.editedTime = updatedTimeOfDay.value;
                if (this.editedTimeOfDay.empty){
                    this.editedTimeOfDay.empty = false;
                }
                this.editedTimeOfDay.value = this.editedTime;
            }  
        }
    }

    onClick(){
        // console.log("TimeOfDayEditor: ", "onClick()");
    }

    submit() {
        this.$emit("blur");
        // console.log("TimeOfDayEditor:", "submit")
        if (this.editedTime === ""){
            if (this.timeOfDay.empty){
                return;
            }
            this.editedTimeOfDay.empty = true;
            this.timeOfDay.empty = true;
        } else {
            if (this.editedTimeOfDay.empty){
                this.editedTimeOfDay.empty = false;
            }
            if (this.timeOfDay.empty){
                this.timeOfDay.empty = false;
            }
            if (this.timeOfDay.value === this.editedTime) {
                // console.log("TimeOfDayEditor:", "time has not changed, no-op!")
                return;
            }
            this.editedTimeOfDay.value = this.editedTime;
            this.timeOfDay.value = this.editedTime;
        }
        this.$emit("change");
    }

}

export default TimeOfDayEditor;
